module.exports = __webpack_public_path__ + "static/media/9.05d55f19.jpg";